import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import React from "react";

import Loading from "components/common/loading/Loading";
import AccountAnalyticChart from "components/pages/dashboard/account_analytic/chart/AccountAnalyticChart";
import AccountAnalyticStat from "components/pages/dashboard/account_analytic/AccountAnalyticStat";
import { useGetAccountAnalyticQuery } from "app/store/dashboard/account_analytic/api/accountAnalyticApi";
import { useSelector } from "react-redux";
import AccountAnalyticYearlyFilter from "./filters/AccountAnalyticYearlyFilter";
import AccountAnalyticAccountFilter from "./filters/AccountAnalyticAccountFilter";
import AccountAnalyticDeviceFilter from "./filters/AccountAnalyticDeviceFilter";

const AccountAnalytic = () => {
  const { yearlyFilter, deviceFilter, accountFilter } = useSelector(
    (state) => state.accountAnalytic
  );
  const { data, isLoading, isFetching } = useGetAccountAnalyticQuery(
    { yearlyFilter, accountFilter, deviceFilter },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Account Analytics
            </Typography>
          </Grid>
          <Grid item>
            <AccountAnalyticAccountFilter />
            <AccountAnalyticDeviceFilter />
            <AccountAnalyticYearlyFilter />
          </Grid>
        </Grid>
        {isLoading || isFetching ? (
          <Loading height="300px" />
        ) : (
          <>
            <AccountAnalyticStat data={data} />

            <Divider style={{ marginBottom: "10px" }} />

            <Grid container item flex={1}>
              <AccountAnalyticChart data={data} filter={yearlyFilter} />
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default AccountAnalytic;
